import { render, staticRenderFns } from "./WidgetsUploadDocument.vue?vue&type=template&id=ef183fc4"
import script from "./WidgetsUploadDocument.vue?vue&type=script&lang=js"
export * from "./WidgetsUploadDocument.vue?vue&type=script&lang=js"
import style0 from "./WidgetsUploadDocument.vue?vue&type=style&index=0&id=ef183fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports